import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export const ParameterTable = ({ parameters = [], config = {} }) => {
  const fmt = (key) => {
    const v = config[key];
    if (typeof v === "boolean") return v ? "true" : "false";
    return String(v);
  };

  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden" data-testid="parameter-reference-table">
      <div className="overflow-auto thin-scroll" style={{ maxHeight: "min(70vh, 720px)" }}>
        <Table className="text-sm">
          <TableHeader className="sticky top-0 z-10 bg-card/95 backdrop-blur">
            <TableRow>
              <TableHead className="min-w-[180px]">Parametro</TableHead>
              <TableHead className="min-w-[260px]">Descrizione</TableHead>
              <TableHead className="min-w-[120px]">Range Oro</TableHead>
              <TableHead className="min-w-[90px] text-right">Valore</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {parameters.map((p) => (
              <TableRow key={p.key}>
                <TableCell>
                  <div className="font-medium">{p.label}</div>
                  <Badge variant="secondary" className="mt-1 text-[10px] md:text-xs">{p.group}</Badge>
                </TableCell>
                <TableCell className="text-muted-foreground text-xs leading-relaxed">{p.help}</TableCell>
                <TableCell className="font-mono text-xs">{p.recommended}</TableCell>
                <TableCell className="text-right font-mono text-xs font-medium">{fmt(p.key)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
